// extracted by mini-css-extract-plugin
module.exports = {"ace_editor":"code_ace_editor__3AxD0"};